import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Typography from "@mui/material/Typography";
import { RichTreeView } from "@mui/x-tree-view/RichTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { Link } from "react-router-dom";
import { Box, Tooltip } from "@mui/material";
import treejson from "../Tempdata/Treejson";
import { useDispatch, useSelector } from "react-redux";
import {
  updatetreepathselected,
  updateselectedtreedashboard,
  updatedashboardMap
} from "../store/mainpage_data";
import Tree_Barodajson from "../Tempdata/Tree_Barodajson";
import Tree_Delhijson from "../Tempdata/Tree_Delhijson";
import Tree_HQjson from "../Tempdata/Tree_HQjson";
import Tree_Kolkatajson from "../Tempdata/Tree_Kolkatajson";
import { TreeItem2 } from "@mui/x-tree-view/TreeItem2";
import Tree_Noida_JBF from "../Tempdata/Tree_Noida_JBF";
import Tree_JBF_D from "../Tempdata/Tree_JBF_D";
import Tree_JBF_DUNK from "../Tempdata/Tree_JBF_DU.js";
import Tree_JBF_P from "../Tempdata/Tree_JBF_P";
import Tree_JBF_H from "../Tempdata/Tree_JBF_H";
import { getDashboardPermissions } from "../Restclient/datacollection";
import { getplantview } from "../Restclient/datacollection";
import { updateplatjson } from "../store/login_data";

var counternew = 1;
export default function Treeviewpage() {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.themedata.theme);
  const projectname = useSelector(
    (state) => state.mainpagedata.selectedprojectname
  );
  const selectedelement = useSelector(
    (state) => state.mainpagedata.treeupdatepath
  );
  const plantjsondata = useSelector((state) => state.logindata.plantjson);
  const logindetails = useSelector((state) => state.logindata.userdetails);
  const selectedtreedashboard = useSelector((state) => state.mainpagedata.selectedtreedashboard);
  const selectedtreepath = useSelector((state) => state.mainpagedata.treepathselected);
  
  const getDashboardPermissionscallback = (response) => {
   
    if(response && response.success && response.success === true){
      dispatch(updatedashboardMap(response.data))
    }
  }

  useEffect(() => {
  
    let treeviewSubDashboardlist = selectedtreedashboard?.subdashboardlist || [];
    let SubdashboardsIDArray = [];

    for(let i=0; i<treeviewSubDashboardlist.length; i++){
      let currentSubArray = treeviewSubDashboardlist[i] || [];
      for(let j=0; j<currentSubArray.length; j++){
        let subdashboardID = currentSubArray[j]?.dashboard_pro || "";
        SubdashboardsIDArray.push(subdashboardID);
      }
    }
    getDashboardPermissions(SubdashboardsIDArray,getDashboardPermissionscallback)

  }, [selectedtreedashboard]);

  const [treeselected, setTreeselected] = useState({
    id: "",
    label: "",
  });
  const [selecteditemid, setSelecteditemid] = useState("");
  const [expandedItems, setExpandedItems] = useState([]);

  const normalize = (value) => String(value || "").toLowerCase().trim();
  const toStringArray = (value) =>
    Array.isArray(value) ? value.map((item) => String(item || "")) : [];
  const arePathsEqual = (a, b) => {
    const pathA = toStringArray(a);
    const pathB = toStringArray(b);
    if (pathA.length !== pathB.length) return false;
    for (let i = 0; i < pathA.length; i++) {
      if (normalize(pathA[i]) !== normalize(pathB[i])) return false;
    }
    return true;
  };
  const normalizeDashboardForCompare = (dashboard) => ({
    id: String(dashboard?.id ?? ""),
    name: normalize(dashboard?.name),
    maindashboardlist: dashboard?.maindashboardlist ?? [],
    subdashboardlist: dashboard?.subdashboardlist ?? [],
  });
  const areDashboardsEqual = (a, b) => {
    const dashA = normalizeDashboardForCompare(a);
    const dashB = normalizeDashboardForCompare(b);
    return (
      dashA.id === dashB.id &&
      dashA.name === dashB.name &&
      JSON.stringify(dashA.maindashboardlist) ===
        JSON.stringify(dashB.maindashboardlist) &&
      JSON.stringify(dashA.subdashboardlist) ===
        JSON.stringify(dashB.subdashboardlist)
    );
  };

  const normalizeTreeNodeIds = (node, fallbackId = "root") => {
    if (!node || typeof node !== "object") return node;
    const resolvedId = node?.id != null
      ? String(node.id)
      : node?.key != null
        ? String(node.key)
        : String(fallbackId);
    const children = Array.isArray(node.children)
      ? node.children.map((child, index) => normalizeTreeNodeIds(child, `${resolvedId}-${index}`))
      : [];
    return {
      ...node,
      id: resolvedId,
      key: resolvedId,
      children,
    };
  };

  var path = [];
  var selectedtreedetails = {};
  const handleitemselected = (event, ids) => {
    const target = event?.target;
    if (target?.closest && target.closest('.MuiTreeItem-iconContainer')) {
      return;
    }

    path = [];
    selectedtreedetails = {};
    const selectedId = ids != null ? String(ids) : "";
    setSelecteditemid(selectedId);
    generateselectedelementpath(selectedId, [treeselected]);
    const nextPath = path.reverse();
    if (!arePathsEqual(selectedtreepath, nextPath)) {
      dispatch(updatetreepathselected(nextPath));
    }
    if (!areDashboardsEqual(selectedtreedashboard, selectedtreedetails)) {
      dispatch(updateselectedtreedashboard(selectedtreedetails));
    }
  };
  const generateselectedelementpath = (key, tree) => {
    for (let i = 0; i < tree.length; i++) {
      const node = tree[i];
      if (!node) continue;
      if (node?.children  && node?.children.length !== 0) {
        if (String(node.id) === String(key)) {
          path.push(node.label);
       
          selectedtreedetails = {
            id: node.id,
            name: node.label,
            maindashboardlist: node.maindashboardlist,
            subdashboardlist: node.subdashboardlist,
          };
          //parentkey = node.key
          return;
        } else {
          generateselectedelementpath(key, node.children);
          if (path.length !== 0) {
            path.push(node.label);
            return;
          }
        }
      } else {
        if (String(node.id) === String(key)) {
          path.push(node.label);
          selectedtreedetails = {
            id: node.id,
            name: node.label,
            maindashboardlist: node.maindashboardlist,
            subdashboardlist: node.subdashboardlist,
          };
          return;
        }
      }
    }
  };

  const extractPlantJsonPayload = (response) => {
    if (!response) return [];
    if (Array.isArray(response)) return response;
    if (Array.isArray(response.plantview)) return response.plantview;
    if (Array.isArray(response.data)) return response.data;
    if (Array.isArray(response.data?.plantview)) return response.data.plantview;
    return [];
  };

  // Refresh plant data from backend whenever the selected project changes
  // (e.g. after returning from Config/Plantview page)
  useEffect(() => {
    if (!projectname || !logindetails?.Organizationid) return;
    getplantview(logindetails.Organizationid, projectname, (res) => {
      const latestPlantJson = extractPlantJsonPayload(res);
      if (latestPlantJson.length) {
        dispatch(updateplatjson(latestPlantJson));
      }
    });
  }, [projectname, logindetails?.Organizationid]);

  useEffect(() => {
   
    if (!Array.isArray(plantjsondata)) return;
    let matchedPlant = null;

    for (let i = 0; i < plantjsondata.length; i++) {
      const plant = plantjsondata[i];
      const selectedProject = normalize(projectname);
      const plantId = normalize(plant?.Projectid);
      const plantName = normalize(plant?.ProjectName || plant?.Projectname);
      if ((selectedProject === plantId || selectedProject === plantName) && Array.isArray(plant?.Plantview) && plant.Plantview.length > 0 && plant.Plantview[0]) {
        matchedPlant = plant;
        break;
      }
    }

    if (!matchedPlant) {
      for (let i = 0; i < plantjsondata.length; i++) {
        const fallbackPlant = plantjsondata[i];
        if (Array.isArray(fallbackPlant?.Plantview) && fallbackPlant.Plantview.length > 0 && fallbackPlant.Plantview[0]) {
          matchedPlant = fallbackPlant;
          break;
        }
      }
    }

    if (!matchedPlant?.Plantview?.[0]) {
      setTreeselected({ id: "", label: "" });
      setSelecteditemid("");
      if (!arePathsEqual(selectedtreepath, [])) {
        dispatch(updatetreepathselected([]));
      }
      if (!areDashboardsEqual(selectedtreedashboard, {})) {
        dispatch(updateselectedtreedashboard({}));
      }
      return;
    }

    const rootNode = normalizeTreeNodeIds(matchedPlant.Plantview[0]);
    setTreeselected(rootNode);

    // If an external navigation already set a deep path for this same root,
    // preserve it. Otherwise, default to root selection for normal project changes.
    const rootLabel = rootNode?.label ?? "";
    const preserveExternalPath =
      Array.isArray(selectedtreepath) &&
      selectedtreepath.length > 0 &&
      normalize(selectedtreepath[0]) === normalize(rootLabel);

    if (!preserveExternalPath) {
      const nextRootPath = rootLabel ? [rootLabel] : [];
      const nextRootDashboard = {
        id: rootNode?.id ?? "",
        name: rootNode?.label ?? "",
        maindashboardlist: rootNode?.maindashboardlist ?? [],
        subdashboardlist: rootNode?.subdashboardlist ?? [],
      };
      setSelecteditemid(String(rootNode?.id ?? ""));
      setExpandedItems([]);
      if (!arePathsEqual(selectedtreepath, nextRootPath)) {
        dispatch(updatetreepathselected(nextRootPath));
      }
      if (!areDashboardsEqual(selectedtreedashboard, nextRootDashboard)) {
        dispatch(updateselectedtreedashboard(nextRootDashboard));
      }
    }
  }, [projectname, plantjsondata]);

  // Apply external treepathselected (e.g. map pin click) to selection + expansion.
  useEffect(() => {
    if (!Array.isArray(selectedtreepath) || selectedtreepath.length === 0) return;
    if (!treeselected?.id) return;

    const collectPathNodes = (nodes, pathArr, depth, accNodes) => {
      if (!Array.isArray(nodes) || depth >= pathArr.length) return null;
      const target = normalize(pathArr[depth]);
      for (const node of nodes) {
        if (normalize(node?.label) === target) {
          const nextNodes = [...accNodes, node];
          if (depth === pathArr.length - 1) return nextNodes;
          const childResult = collectPathNodes(node?.children || [], pathArr, depth + 1, nextNodes);
          if (childResult && childResult.length > 0) {
            return childResult;
          }
        }
      }
      return null;
    };

    const nodePath = collectPathNodes([treeselected], selectedtreepath, 0, []);
    if (!nodePath || nodePath.length === 0) return;

    const ids = nodePath
      .map((node) => (node?.id != null ? String(node.id) : ""))
      .filter((id) => id !== "");
    if (!ids.length) return;

    const leafNode = nodePath[nodePath.length - 1];
    const leafId = ids[ids.length - 1];
    const ancestorIds = ids.length === 1 ? ids : ids.slice(0, -1);

    const currentSelected = selecteditemid != null ? String(selecteditemid) : "";
    const isExternalSelection = String(leafId) !== currentSelected;
    if (isExternalSelection) {
      setExpandedItems(Array.from(new Set(ancestorIds)));
    }
    if (String(leafId) !== currentSelected) {
      setSelecteditemid(leafId);
    }
    const nextLeafDashboard = {
      id: leafNode?.id ?? "",
      name: leafNode?.label ?? "",
      maindashboardlist: leafNode?.maindashboardlist ?? [],
      subdashboardlist: leafNode?.subdashboardlist ?? [],
    };
    if (!areDashboardsEqual(selectedtreedashboard, nextLeafDashboard)) {
      dispatch(updateselectedtreedashboard(nextLeafDashboard));
    }
  }, [selectedtreepath, treeselected]);

  const [labelid, setlabelid] = useState("");
  function isEllipsisActive(e) {
    return e.offsetWidth < e.scrollWidth;
  }



  const CustomTreeItem = React.forwardRef((props, ref) => (
    <Tooltip
      title={props.label}
      placement="left"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "#005C8E",
            color: "#FFFFFF",
            borderRadius: "0px 0px 0px 10px",
            fontSize: "12px",
            fontWeight: 400,
            padding: "10px",
          },
        },
      }}
    >
      <TreeItem2
        ref={ref}
        {...props}
        slotProps={{
          label: {
            id: `${props.itemId}-label`,
          },
        }}
        />
    </Tooltip>
  ));

  return (
    <Box
      sx={{
        height: "100%",
        textAlign: "left",
        margin: "10px",
        overflow: "auto",
      }}
    >
      <Tooltip>
        <RichTreeView
          sx={{
            "& MuiTreeItem-group": {
              color: "var(--action-button-light) !important",
              fontWeight: "700 !important",
            },
            "& .Mui-selected:hover": {
              backgroundColor: "transparent !important",
            },
            "& .Mui-selected": {
              backgroundColor: "transparent !important",
              color: "#008CD7 !important",
              fontWeight: "900 !important",
            },
            "& .MuiTreeItem.Mui-focused": {
              backgroundColor: "transparent !important",
              color: "var(--action-button-light) !important",
              fontWeight: "700 !important",
            },
            // '& .Mui-selected .MuiTreeItem-content': {
            //     backgroundColor: 'transparent !important',
            //     color: '#008CD7 !important',
            //     fontWeight: '700 !important'
            // },
            "& .MuiTreeItem-label": {
              fontSize: "16px",
              fontWeight: 400,
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            },
            color: "var(--PrimaryText)",
            fontSize: "50px",
          }}
          items={treeselected?.id ? [treeselected] : []}
          onSelectedItemsChange={handleitemselected}
          aria-label="customized"
          selectedItems={selecteditemid}
          expandedItems={expandedItems}
          onExpandedItemsChange={(event, newExpanded) =>
            setExpandedItems(Array.isArray(newExpanded) ? newExpanded.map((id) => String(id)) : [])
          }
          //slots={{ item: CustomTreeItem }}
        />
      </Tooltip>
    </Box>
  );
}

/*
<TreeView
            defaultExpanded={['1', '2', '3', '4', '5', '6', '7']}
            aria-label="file system navigator"
            defaultCollapseIcon={<ExpandMoreIcon sx={{ color: 'var(--treeview-icon)' }} />}
            defaultExpandIcon={<ChevronRightIcon sx={{ color: 'var(--treeview-icon)' }} />}
            sx={{
            
                height: '100%',
                width: '185px',
                '& MuiTreeItem-group': {
                    color: 'var(--action-button-light) !important',
                    fontWeight: '700 !important'
                },
                '& .Mui-selected:hover': {
                    backgroundColor: 'transparent !important',
                },
                '& .Mui-selected': {
                    backgroundColor: 'transparent !important',
                    color: 'var(--action-button-light) !important',
                    fontWeight: '700 !important'
                },
                '& .Mui-focused': {
                    backgroundColor: 'transparent !important',
                    color: 'var(--action-button-light) !important',
                    fontWeight: '700 !important'
                },
                '& .Mui-selected .MuiTreeItem-content': {
                    backgroundColor: 'transparent !important',
                    color: 'var(--action-button-light) !important',
                    fontWeight: '700 !important'
                },
            }}
        >
            <TreeItem nodeId="1" label={

                <Link to="/vsw" style={{ textDecoration: 'none', color: 'inherit' }}>
                    <Typography sx={treeItemStyle}>VSW Plant</Typography>
                </Link>

            }>
                <TreeItem nodeId="2" label={
                    <Typography sx={treeItemStyle}>RMU VCB</Typography>
                } icon={<ChevronRightIcon sx={{ color: 'var(--treeview-icon)' }} />} />

                <TreeItem nodeId="3" label={
                    <Typography sx={treeItemStyle}>PCC 1</Typography>
                } icon={<ChevronRightIcon sx={{ color: 'var(--treeview-icon)' }} />} />

                <TreeItem nodeId="4" label={
                    <Typography sx={treeItemStyle}>PCC 2</Typography>
                } icon={<ChevronRightIcon sx={{ color: 'var(--treeview-icon)' }} />} />

                <TreeItem nodeId="5" label={
                    <Typography sx={treeItemStyle}>UPS Panel</Typography>
                } icon={<ChevronRightIcon sx={{ color: 'var(--treeview-icon)' }} />} />

                <TreeItem nodeId="6" label={
                    <Typography sx={treeItemStyle}>ACB Release</Typography>
                }>
                    <TreeItem nodeId="7" label={
                        <Typography sx={treeItemStyle}>PCC 1</Typography>
                    } icon={<ChevronRightIcon sx={{ color: 'var(--treeview-icon)' }} />} />
                </TreeItem>
            </TreeItem>
        </TreeView>
*/
